<section>
    <div>
        <form [formGroup]="updateClient">
            <div class="form-group">
                <label for="umi-marital-status">Marital status</label>
                <input id="umi-marital-status" formControlName="marital status" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-job">Job</label>
                <input id="umi-job" formControlName="job" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-favorite-colour">Favorite colour</label>
                <input id="umi-favorite-colour" formControlName="favorite colour" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-how-know-us">How did you know us</label>
                <input id="umi-how-know-us" formControlName="how did you know us" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-goal">Your ultimate goal</label>
                <input id="umi-goal" formControlName="your ultimate goal" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-happy">How you make yourself happy</label>
                <input id="umi-happy" formControlName="how you make yourself happy" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-spare-time">How do you spend your spare time</label>
                <input id="umi-spare-time" formControlName="how do you spend your spare time" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="umi-surprises">Do you like surprises, if yes, what's your best surprise</label>
                <input id="umi-surprises" formControlName="do you like surprises, if yes, what's your best surprise" type="text" class="form-control">
            </div>

            <button (click)="onNoClick()" class="btn save">Save</button>
            <button (click)="skip()" class=" btn skip">Skip</button>
        </form>
    </div>
</section>
